export default __webpack_public_path__ + "static/media/9.8960e9ec.jpg";